import { Comment } from "../../types";

type CoachComment = Pick<Comment, "coach" | "emotion">;
export type Coach = NonNullable<Comment["coach"]>;

// Comments from before the coach column have no coach. They keep the shared name and both portraits.
export const coachLabel = (c: CoachComment, t: (key: string) => string) =>
  c.coach === "rhys" ? t("coachRhys") : c.coach === "lisa" ? t("coachLisa") : t("coachNames");

export const coachPortrait = (coach: Coach) => `/assets/coach-${coach}.jpg`;

export const coachImages = (c: CoachComment) => (c.coach ? [coachPortrait(c.coach)] : [coachPortrait("rhys"), coachPortrait("lisa")]);
